import { useEffect, useState } from "react";
import { Outlet, useLocation } from "react-router-dom";
import { Nav, NavItem, NavLink } from "reactstrap";
import { UserRoleType } from "../../types/constants";
import { RoutePath, parseRoutePath } from "../../router";
import AuthWrapper from "../common/auth-wrapper";
import { AddressManager } from "./address/address-manager";
import AuditLogProvider from "./log/audit-log-provider";
import Publish from "./publish/publish";
import UserManager from "./security/user-manager";
import ValueListManager from "./value-list/value-list-manager";
import PiT from "./pit/pit";
import { PositionManager } from "./position-titles/position-manager";
import QueryProvider from "./query/query-provider";

export const adminRoutes = [
  {
    index: true,
    element: <UserManager />,
    title: 'Security'
  },
  {
    path: 'position-role',
    element: <PositionManager />,
    title: 'Position/Role Titles'
  },
  {
    path: 'address',
    element: <AddressManager />,
    title: 'Addresses'
  },
  {
    path: 'value-list',
    element: <ValueListManager />,
    title: 'Value List'
  },
  {
    path: 'publish',
    element: <Publish />,
    title: 'Publish'
  },
  {
    path: 'audit-log',
    element: <AuditLogProvider />,
    title: 'Audit Log'
  },
  {
    path: 'query',
    element: <QueryProvider />,
    title: 'Query'
  },
  {
    path: 'report',
    element: <PiT></PiT>,
    title: 'PiT Report'
  },
];

export function Administration() {
  const [activeTab, setActiveTab] = useState(0); // tab index

  const location = useLocation();
  useEffect(() => {
    const pathname = location.pathname;
    adminRoutes.forEach((r, i) => {
      if (pathname.startsWith(`/${RoutePath.Administration}/${r.path}`)) {
        setActiveTab(i);
      }
    });
  }, [location.pathname]);

  return (
    <AuthWrapper role={UserRoleType.ADMINISTRATOR}>
      <h1 className="hidden-text">Administration</h1>

      <div className="oms-frame">
        <Nav tabs card>
          {
            adminRoutes.map((r, i) => r.title &&
              <NavItem key={i}>
                <NavLink active={i == activeTab} onClick={() => setActiveTab(i)}
                  href={`${parseRoutePath(RoutePath.Administration)}${r.path ? '/' + r.path : ''}`}>
                  {r.title}
                </NavLink>
              </NavItem>
            )
          }
        </Nav>

        <div className="oms-container p-3">
          <Outlet />
        </div>
      </div>
    </AuthWrapper>
  );
}
